import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import * as yup from 'yup';

const gtZero = (value) => value !== '' && value !== null && value !== undefined && value > 0;

const produtosServicosSchema = yup.array(
  yup.object().shape({
    produtoServico: yup
      .object()
      .nullable()
      .required(mensagemCampoObrigatorio('o produto/serviço')),
    quantidade: yup
      .number()
      .nullable()
      .required('A quantidade deve ser superior a zero')
      .test('quantidadeGtZero', 'A quantidade deve ser superior a zero', gtZero),
    valor: yup
      .number()
      .nullable()
      .required(mensagemCampoObrigatorio('o valor'))
      .test('valorGtZero', mensagemCampoObrigatorio('o valor'), gtZero),
  })
);

const schemaNotaRemessa = yup.object().shape({
  operacao: yup
    .string()
    .nullable()
    .required(mensagemCampoObrigatorio('a operação')),
  motivoRemessa: yup
    .string()
    .nullable()
    .required(mensagemCampoObrigatorio('motivo da remessa')),
  destinatario: yup
    .object()
    .nullable()
    .test('destinatario', mensagemCampoObrigatorio('o destinatário'), function(destinatario) {
      return !!destinatario?.id;
    }),
  produtosServicos: produtosServicosSchema,
  valorDesconto: yup
    .number()
    .nullable()
    .test('valorDesconto', mensagemCampoObrigatorio('o desconto'), function(valorDesconto) {
      const tipoDesconto = this.parent.tipoDesconto !== ' ' ? this.parent.tipoDesconto : false;

      return tipoDesconto ? valorDesconto !== '' && valorDesconto !== null && valorDesconto !== undefined : true;
    })
    .test('valorDesconto', 'O valor deve ser superior a zero', function(valorDesconto) {
      const tipoDesconto = this.parent.tipoDesconto !== ' ' ? this.parent.tipoDesconto : false;

      return tipoDesconto ? gtZero(valorDesconto) : true;
    })
    .test('valorDesconto', 'O valor de desconto não pode ser maior que o somatório dos subtotais', function(
      valorDesconto
    ) {
      const tipoDesconto = this.parent.tipoDesconto !== ' ' ? this.parent.tipoDesconto : false;
      return tipoDesconto ? this.parent.valorTotal + valorDesconto > valorDesconto : true;
    }),
});

export default schemaNotaRemessa;
